export enum DosageTypeError {
  creatinine,
  patientBirthdate,
  weight,
  unknown,
}



// WEBPACK FOOTER //
// ./src/models/creatinine/dossage-type-error.ts